// src/pages/PrivacyPolicy.js
import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  document.title = "Privacy Policy | Skillsverse Academy";

  return (
    <div className="policy-container">
      <header className="policy-header">
        <h1>Privacy Policy</h1>
        <p className="policy-subtitle">
          Effective date: {new Date().toLocaleDateString()}
        </p>
      </header>

      <section className="policy-section">
        <p>
          We collect your <strong>name, phone number, and email</strong> to
          contact you about course details, enrollment, and upcoming batches.
        </p>
        <p>
          Your information will <strong>never be sold or shared</strong> with
          third parties. We use your data only for communication related to{" "}
          <strong>Skillsverse Academy</strong>.
        </p>
        <p>
          To protect your privacy, we apply security measures to keep your
          information safe from unauthorized access. You also have the right to
          request updates or deletion of your personal data at any time.
        </p>
        <p>
          For any request to update or delete your data, contact us at: <br />
          <strong>skillsverseacademy@gmail.com</strong>
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
